import { PriceReduction } from './price-reduction';

/**
 * Price category class that is part of the lottery
 */
export class PriceCategory {
  public id: string;
  public '@id': string;
  public name: boolean;
  public color: string;
  public amount: any;
  public currencyCode: boolean;
  public capacity: number;
  public assignedReductions: Array<PriceCategoryAssignedReduction> = [];

  public i18nSeats = $localize`:@@general.text.seats:seats`;

  constructor(priceCategory: any) {
    this.id = priceCategory.id;
    this['@id'] = priceCategory['@id'];
    this.name = priceCategory.name;
    this.color = priceCategory.color;
    this.capacity = priceCategory.capacity;
    this.amount = parseFloat((priceCategory.amount / 100).toString()).toFixed(2);
    this.currencyCode = priceCategory.currencyCode;
    for (const assignedReduction of priceCategory.assignedReductions) {
      this.assignedReductions.push(new PriceCategoryAssignedReduction(assignedReduction));
    }
  }

  get fullPrice(): string {
    return `${this.amount} ${this.currencyCode}`;
  }

  get allReductions(): string {
    const arr = [];
    for (const assignedReduction of this.assignedReductions) {
      arr.push(assignedReduction.reduction.name);
    }
    return arr.join(', ');
  }

  get nameAndSeats(): string {
    return `${this.name} [${this.capacity} ${this.i18nSeats}]`;
  }
}

/**
 * Price category assigned reduction class that is part of the lottery
 */
export class PriceCategoryAssignedReduction {
  public id: number;
  public currencyCode: string;
  public reducedAmount: any;
  public reduction: PriceReduction;

  constructor(assignedReduction: any) {
    this.id = assignedReduction.id;
    this.currencyCode = assignedReduction.currencyCode;
    this.reducedAmount = parseFloat((assignedReduction.reducedAmount / 100).toString()).toFixed(2);
    this.reduction = new PriceReduction(assignedReduction.reduction);
  }

  get fullPrice(): string {
    return `${this.reducedAmount} ${this.currencyCode}`;
  }

  get fullName(): string {
    return `${this.reduction.name} (${this.fullPrice})`;
  }
}
